import service from '@/utils/server';

const MOD = '/log/sapIntDatapack/';
const SELECT_MOD = '/common/web/select/';

export const pageInfo = data => {
  return service({
    url: MOD + 'pageInfo',
    method: 'post',
    data
  });
};

export const detail = id => {
  return service({
    url: MOD + 'detail/' + id,
    method: 'post',
    data: {}
  });
};

export const businessTypeList = () => {
  return service({
    url: SELECT_MOD + 'datapackBusinessTypeList',
    method: 'post',
    data: {}
  });
};



// WEBPACK FOOTER //
// ./src/page/log/sapIntDatapack/api/index.js